// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-3d6tA";
var _3 = "checkbox-2xJoE";
var _4 = "checkbox__label-1usI0";
var _5 = "checkbox__root-3A1R-";
var _6 = "checkbox__checked-3odei";
var _7 = "checkbox__price-3Smpn";
var _8 = "select-3FkAg";
var _9 = "select_root-3j5DH";
var _a = "passenger-2Fau-";
var _b = "passenger_vipService-2afJS";
var _c = "control-3HFkg";
var _d = "control_counter-MeKgM";
var _e = "label-3x_fT";
var _f = "price-1q_1f";
export { _1 as "__esModule", _2 as "container", _3 as "checkbox", _4 as "checkbox__label", _5 as "checkbox__root", _6 as "checkbox__checked", _7 as "checkbox__price", _8 as "select", _9 as "select_root", _a as "passenger", _b as "passenger_vipService", _c as "control", _d as "control_counter", _e as "label", _f as "price" }
export default { "__esModule": _1, "container": _2, "checkbox": _3, "checkbox__label": _4, "checkbox__root": _5, "checkbox__checked": _6, "checkbox__price": _7, "select": _8, "select_root": _9, "passenger": _a, "passenger_vipService": _b, "control": _c, "control_counter": _d, "label": _e, "price": _f }
